import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const CoachNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="url(#CoachNotification1)" />
    <Path
      d="m15.339 13.162-.455-.775a1.768 1.768 0 0 1-.182-.69v-1.18c0-.522-.145-1.032-.416-1.472a2.712 2.712 0 0 0-1.118-1.016 1.35 1.35 0 0 0-.494-.513 1.342 1.342 0 0 0-1.858.526 2.774 2.774 0 0 0-1.502 2.474v1.18c0 .192-.086.519-.182.687l-.46.779a1.145 1.145 0 0 0-.109.975c.11.313.369.556.706.672a8.317 8.317 0 0 0 2.739.458c.928 0 1.857-.15 2.74-.453.318-.107.564-.355.682-.677a1.134 1.134 0 0 0-.091-.975Zm-2.052 2.576c-.096.272-.271.507-.501.673a1.333 1.333 0 0 1-1.751-.16 1.293 1.293 0 0 1-.32-.518c.06.01.119.014.183.024a8.781 8.781 0 0 0 1.11.075c.26 0 .519-.015.773-.038.096-.01.192-.014.283-.028l.223-.028Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="CoachNotification1"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#FB60BA" />
        <Stop offset="1" stopColor="#DC1D8C" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default CoachNotification;
